import { render, staticRenderFns } from "./cSocMediaMetric.vue?vue&type=template&id=382d5c3e&scoped=true&"
import script from "./cSocMediaMetric.vue?vue&type=script&lang=js&"
export * from "./cSocMediaMetric.vue?vue&type=script&lang=js&"
import style0 from "./cSocMediaMetric.vue?vue&type=style&index=0&id=382d5c3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382d5c3e",
  null
  
)

export default component.exports